import {FlowConfigInterface} from 'app/components/onboardingFlows/flows/common/FlowConfigInterface';
import LocalStorageManager from 'app/services/web-storage/LocalStorageManager';
import isGreaterSemVersionThan from 'app/components/match/matchLive/isGreaterSemVersionThan';
import {isNativeApp} from 'app/helpers/nativeHelpers';

const DAY_IN_MINUTES = 24 * 60;
abstract class FlowConfigAbstract implements FlowConfigInterface {
  public abstract readonly id: string;
  public abstract readonly title: string;
  public abstract readonly description: string;
  public abstract readonly animationSrc: string;
  protected abstract readonly start_time: Date;
  protected abstract readonly available_until: Date;
  protected abstract readonly reshowInDays: number | null;

  public abstract isAllowedToDisplay(pathname: string): boolean;

  public handleOnClose(): void {
    this.setViewed();
  }

  private isAvailable(): boolean {
    const currentTime = new Date();
    return currentTime < this.available_until && currentTime > this.start_time;
  }

  private getStoreKey(): string {
    return `onboarding_flow_id_${this.id}_viewed`;
  }

  private isViewed(): boolean {
    const item = LocalStorageManager.getInstance().getItem(this.getStoreKey());
    return !!item;
  }

  protected isAvailableAndNotViewed(): boolean {
    return this.isAvailable() && !this.isViewed();
  }

  private setViewed(): void {
    const expiresIn = this.reshowInDays ? this.reshowInDays * DAY_IN_MINUTES : this.available_until;
    LocalStorageManager.getInstance().setItem(this.getStoreKey(), true, expiresIn);
  }

  protected isNative(): boolean {
    return isNativeApp();
  }

  protected isSupportedNativeVersion(buildVersion: string, minVersion: string): boolean {
    if (!this.isNative()) {
      return false;
    }

    return isGreaterSemVersionThan(buildVersion, minVersion);
  }
}

export default FlowConfigAbstract;
